export function initIubendaEmbeds() {
  // If the script isn’t on the page yet, add it now
  if (!document.querySelector('script[src^="https://cdn.iubenda.com/iubenda.js"]')) {
    const s = document.createElement('script');
    s.src = 'https://cdn.iubenda.com/iubenda.js';
    s.async = true;
    document.body.appendChild(s);
    return;
  }

  // If it *is* on the page already, reload it so it reparses new links
  // (matches Iubenda’s own async-initializer approach)
  const s = document.createElement('script');
  s.src = 'https://cdn.iubenda.com/iubenda.js';
  s.async = true;
  document.body.appendChild(s);
}